/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDragAndDropMethods } from "./use-drag-and-drop-methods";
import { useMutableItemList } from "./use-mutable-item-list";

/**
 * @template {ItemWithPosition} T
 * @param {T[]} initialItems
 * @param {keyof T} idField
 * @param {(items: T[]) => void} save
 * @param {OnDragSwap<T>=} onSwap
 */
export function useItemSwap (initialItems, idField, save, onSwap) {

    const [items, setItems] = useMutableItemList(initialItems, idField, null, save);
    const sortableMethods = useDragAndDropMethods(items, setItems, idField, onSwap);

    /** @type {[T[], SortableMethods<T>]} */
    const swapTuple = [
        items,
        sortableMethods
    ];

    return swapTuple;
}
